import * as ko from "knockout";
import {_} from 'lodash';
import {ICompanyLogin} from "../../index";
import {CompanyLogin} from "../../auth/CompanyLogin";
import {global, lm} from "../../appContext";
import {storeObservable} from "../../util/sessionstore";
import {IComboboxV2Options} from "../combobox/v2";
import company_selectHtml from './company-select.html?raw';

export let template: string = company_selectHtml;

export class CompanySelect {

    private companyLogin: CompanyLogin = global.companyLogin;
    public orgid: KnockoutObservable<ICompanyLogin["orgnr"] | null> = ko.observable(null);
    public organizations = ko.observableArray<ICompanyLogin>([]);
    public isLoaded = ko.observable(false);
    public loadError = ko.observable<string | null>(null);
    public readonly v2Options: IComboboxV2Options<ICompanyLogin>;

    public readonly optionsCaption = ko.pureComputed(() => {
        storeObservable("language")();
        return lm.t("choose organization|td");
    });

    public readonly ariaLabel = ko.pureComputed(() => {
        storeObservable("language")();
        return lm.t("choose organization");
    });

    public readonly selectedOrg = ko.computed<ICompanyLogin | null>({
        read: () => this.companyLogin.selected() ?? null,
        write: (v: ICompanyLogin | null | undefined) => {
            const next = v ?? null;
            this.companyLogin.selected(next);
            this.orgid(next?.orgnr ?? null);
        },
    });

    constructor() {
        this.v2Options = {
            data: this.organizations,
            selected: this.selectedOrg,
            enable: ko.pureComputed(() => this.isLoaded() && !this.loadError()),
            caret: 'light',
            wrapperClass: 'login-page__org-combobox',
            restoreLastValidOnBlur: true,
            inputAttrs: {
                placeholder: this.optionsCaption,
                title: this.ariaLabel,
                ariaLabel: this.ariaLabel,
            },
            option: {
                label: o => o?.name ?? '',
                key: o => `${o.orgnr}:${o.vanityindex}`,
                sortBy: [o => (o?.name ?? '').toLowerCase()],
                match: (o, s) => !s
                    || (o?.name ?? '').toLowerCase().includes(s)
                    || String(o?.orgnr ?? '').toLowerCase().includes(s),
            },
            initialMatch: o => {
                const sel = this.companyLogin.selected();
                return !!sel && o.orgnr == sel.orgnr && o.vanityindex == sel.vanityindex;
            },
        };

        this.loadOrganizations();
    }

    /** Ny innlasting etter fatal feil (organisasjonsliste). */
    retryLoad(): void {
        this.loadError(null);
        this.isLoaded(false);
        this.organizations([]);
        this.loadOrganizations();
    }

    private loadOrganizations(): void {
        this.companyLogin
            .request()
            .then((data: ICompanyLogin[]) => {
                const d = data;
                










                let visible = _.sortBy(
                    d.filter((o: ICompanyLogin) => !o.hidename),
                    (o: ICompanyLogin) => o.name.toLowerCase(),
                );
                const sel = this.companyLogin.selected();
                if (
                    sel &&
                    !visible.some(
                        (o: ICompanyLogin) => o.orgnr == sel.orgnr && o.vanityindex == sel.vanityindex,
                    )
                ) {
                    visible = _.sortBy([...visible, sel], (o: ICompanyLogin) => o.name.toLowerCase());
                }
                this.organizations(visible);

                this.isLoaded(true);
                return d;
            })
            .catch((reason: unknown) => {
                this.loadError(String(reason ?? "error"));
                this.isLoaded(true);
            });
    }

    /** Når valgt org settes etter at listen er bygget (f.eks. fra hash), sørg for at den finnes i combobox-kilden. */
    mergeOrganizationIntoVisibleList(cl: ICompanyLogin): void {
        if (!cl) {
            return;
        }
        const visible = this.organizations();
        if (visible.some(o => o.orgnr == cl.orgnr && o.vanityindex == cl.vanityindex)) {
            return;
        }
        this.organizations(_.sortBy([...visible, cl], (o: ICompanyLogin) => (o?.name ?? "").toLowerCase()));
    }

}
